module.exports = __webpack_public_path__ + "img/m1-en.e100bb0f.jpeg";